import { Link, createFileRoute } from "@tanstack/react-router"

import { RunTable } from "@/components/run-table"
import { SessionTable } from "@/components/session-table"
import { ThreadTable } from "@/components/thread-table"
import { PageHeader } from "@/components/page-header"
import { Button } from "@/components/ui/button"
import {
  useCoachThreads,
  usePersonas,
  useProcessRuns,
  useSessions,
} from "@/lib/queries"
import { useCoach } from "@/lib/use-coach"
import { COACH_FALLBACK_LABEL } from "@nl/shared"

function HistoryPage() {
  const { data: runs = [], isLoading } = useProcessRuns()
  const { data: sessions = [] } = useSessions()
  const { data: personas = [] } = usePersonas()
  const { data: threads = [], isLoading: threadsLoading } = useCoachThreads()
  const coach = useCoach()

  // Legacy: sessions trained before the run-centric history existed. Phase
  // sessions of a Durchlauf live inside their run's review, not here.
  const standaloneSessions = sessions.filter((s) => !s.processRunId)
  // Untitled threads were opened but never used; there is nothing to reopen.
  const namedThreads = threads.filter((thread) => thread.title)

  return (
    <div className="space-y-7">
      <PageHeader
        title="Verlauf"
        description="Nur für dich sichtbar. Führungskräfte sehen weder Chatverläufe noch individuelle Scores."
        actions={
          <Button asChild>
            <Link to="/durchlauf">Neues Training</Link>
          </Button>
        }
      />

      <section className="space-y-3">
        <h2 className="font-display text-[18px] font-medium tracking-tight">
          Gesprächstrainings
        </h2>
        <RunTable runs={runs} personas={personas} isLoading={isLoading} />
      </section>

      {namedThreads.length > 0 && (
        <section className="space-y-3">
          <h2 className="font-display text-[18px] font-medium tracking-tight">
            Gespräche mit {coach?.name ?? `dem ${COACH_FALLBACK_LABEL}`}
          </h2>
          <ThreadTable threads={namedThreads} isLoading={threadsLoading} />
        </section>
      )}

      {standaloneSessions.length > 0 && (
        <section className="space-y-3">
          <h2 className="font-display text-[18px] font-medium tracking-tight">
            Einzelne Sessions
          </h2>
          <p className="text-[13.5px] leading-relaxed text-muted-foreground">
            Aus der Zeit vor den Gesprächstrainings. Sie haben keine eigene
            Ansicht mehr; du kannst sie hier löschen.
          </p>
          <SessionTable sessions={standaloneSessions} personas={personas} />
        </section>
      )}
    </div>
  )
}

export const Route = createFileRoute("/_app/history")({
  component: HistoryPage,
})
